exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.invalid-feedback[data-v-7b9683c8]{\n    display: block !important;\n}\n.error[data-v-7b9683c8]{\n    border-color: #c00 !important;\n}\n.alert[data-v-7b9683c8]{\n    font-size: 14px;\n}\n", ""]);

// exports
